import React, { useEffect, useState } from 'react';
import AdminFinancials from '../AdminFinancials';

export default function ChairmanFinancials({ token }) {
  const [financeData, setFinanceData] = useState({ headers: [], rows: [] });
  const [financeLoading, setFinanceLoading] = useState(false);
  const [financeError, setFinanceError] = useState('');

  const fetchFinance = async () => {
    setFinanceError('');
    setFinanceLoading(true);
    try {
      const res = await fetch('/.netlify/functions/admin-get-finance', {
        headers: { Authorization: `Bearer ${token}` }
      });

      const raw = await res.text();
      let json = {};
      try { json = raw ? JSON.parse(raw) : {}; } catch { json = { error: raw }; }

      if (!res.ok) {
        setFinanceError(json?.error || `Failed to load finance: ${res.status}`);
        setFinanceData({ headers: [], rows: [] });
        return;
      }

      const rows = Array.isArray(json.rows) ? json.rows : [];
      rows.sort((a, b) => {
        const at = Date.parse(a.createdAt || a.created_at || '') || 0;
        const bt = Date.parse(b.createdAt || b.created_at || '') || 0;
        return bt - at;
      });

      setFinanceData({ headers: json.headers || [], rows });
    } catch {
      setFinanceError('Network error while fetching finance');
      setFinanceData({ headers: [], rows: [] });
    } finally {
      setFinanceLoading(false);
    }
  };

  useEffect(() => {
    if (!token) return;
    fetchFinance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  // Pass dummy setters because AdminFinancials expects them (we’re in view-only mode)
  return (
    <AdminFinancials
      token={token}
      financeData={financeData}
      financeLoading={financeLoading}
      financeError={financeError}
      finDate=""
      setFinDate={() => {}}
      finCategory=""
      setFinCategory={() => {}}
      finDescription=""
      setFinDescription={() => {}}
      finAmount=""
      setFinAmount={() => {}}
      finMethod=""
      setFinMethod={() => {}}
      finNotes=""
      setFinNotes={() => {}}
      fetchFinance={fetchFinance}
      addFinance={() => {}}
      readOnly={true}
    />
  );
}
